import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CourseDetail61 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>詳細課程內容:</span>
        </h2>
        <p>
          此課程包含Python3由淺至深的內容，帶你學習全面的Python基本與實作必要知識。超過40小時的課程，包含基本語法、程式架構、邏輯思路、問題處理、Debug技巧，建立扎實與全面的Python必備知識!
          Udemy上面有許多課程，但此課程是適合所有層級學習者的全面課程！
        </p>
        <p>
          {" "}
          耗時5個月的構思與準備，加上設計與影片製作，這堂課包含所有你需要的工具與知識，來成為一位Python開發者，製作出任何實用的商業與便捷功能，連結資料庫，寫出精美、維護性以及功能性高的程式碼。此課程會不斷更新以提供新的內容，根據學生的狀況與全球網頁開發趨勢，不斷更新讓知識保持新鮮且豐富。
          本課程講解各種現代開發工具以及應用原則，讓你不論身在何處都可以隨時隨地的學習最新知識。詳細的解說，讓你從初學者到大師!
          所有project皆提供原始碼與教學，讓你輕鬆動手寫程式!
          不用花大錢，即可由簡入深學習到許多開發技巧和debug觀念!
        </p>
      </motion.div>
    </div>
  );
};

export default CourseDetail61;
